import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";

import "../../styles/common/rangeSlider/rangeSlider.scss";

import ReactSlider from "react-slider";

const RangeSlider = forwardRef(({ min, max, onChange, selectedVal }, ref) => {
  const [value, setValue] = useState([min, max]);

  useEffect(() => {
    setValue([min, max]);
  }, [min, max]);

  useImperativeHandle(ref, (val) => ({
    updateSliderValues(val) {
      setValue(val);
    },
  }));

  const handelOnChange = (value, index) => {
    setValue(value);
    onChange(value);
  };

  useEffect(() => {
    if (selectedVal.length > 0) {
      setValue(selectedVal);
    }
  }, []);

  return (
    <ReactSlider
      className="horizontal-slider"
      thumbClassName="example-thumb"
      trackClassName="example-track"
      minDistance={10}
      min={min}
      max={max}
      defaultValue={[min, max]}
      value={value}
      onChange={(value, index) => handelOnChange(value, index)}
      pearling
    />
  );
});

export default RangeSlider;
